import React from 'react';
import styles from '../AddRateModal.module.scss';
import {useTranslation} from 'react-i18next';
import {getCurrencyLabel} from '../../../constants/currencies';

interface PriceBreakdownProps {
    selectValue: {[key: string]: string};
};

const PriceBreakDown = ({selectValue}: PriceBreakdownProps) => {
    const {t} = useTranslation();
    const alfanPercantage = 5;

    const getAmount = (type: string, amount: any, alfanPercantage: any) => {
        let price: any = 0;
        if (type == 'alfanCut') {
          price = (Number(amount) * (Number(alfanPercantage)/100));
       } else if (type == 'stripeCharge') {
          price = (Number(amount) * 0.035);
       } else if (type == 'processingFee') {
            price = (Number(amount) * 0.03);
        } else {
          price = (Number(amount) - (Number(Number(amount) * (Number(alfanPercantage)/100))) - (Number(Number(amount) * (Number(3)/100)))); 
        }
        return isNaN(price) ? '0' : price;
    };

    return (
        <>
            <div className={styles.content_row}>
                <div className={styles.content_row_left}>
                    <div className={styles.breakdown_title}>{t('you_will_receive')}</div>
                    <div className={styles.sub_title_breakdown}>{t('the_estimated_amount_you_will_get')}</div>
                </div>
                <div className={styles.content_row_right}>
                    {getCurrencyLabel(selectValue.currency)} {(getAmount('earn', selectValue.price, alfanPercantage)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </div>
            </div>
            <div className={styles.content_row}>
                <div className={styles.content_row_left}>
                    <div className={styles.breakdown_title}>{`${alfanPercantage}% ${t('alfan_service_fee')}`}</div>
                </div>
                <div className={styles.content_row_right}>
                    {getCurrencyLabel(selectValue.currency)} {(getAmount('alfanCut', selectValue.price, alfanPercantage)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </div>
            </div>
            <div className={styles.content_row}>
                <div className={styles.content_row_left}>
                    <div className={styles.breakdown_title}>{`${t('payment_processing_fee')}`}</div>
                </div>
                <div className={styles.content_row_right}>
                    {getCurrencyLabel(selectValue.currency)} {(getAmount('processingFee', selectValue.price, alfanPercantage)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </div>
            </div>
        </>
    );
};

export default PriceBreakDown;
